export const GIFT_CARD_PRODUCT_ID = "8787546636585";

export const sizes = [24, 48, 72]

export const sortOptions = [
    {
        id: 'score',
        value: {
            name: 'Featured',
            sort: [
                {
                    field: 'score',
                    order: 'desc',
                },
            ],
        },
    },
    {
        id: 'price',
        value: {
            name: 'Price: Low to High',
            sort: [
                {
                    field: 'price',
                    order: 'asc',
                },
            ],
        },
    },
    {
        id: '-price',
        value: {
            name: 'Price: High to Low',
            sort: [
                {
                    field: 'price',
                    order: 'desc',
                },
            ],
        },
    },
    {
        id: 'newest',
        value: {
            name: 'Newest',
            sort: [
                {
                    field: 'datePublished',
                    order: 'desc',
                },
            ],
        },
    },
    {
        id: 'highest_rate',
        value: {
            name: 'Highest Rate',
            sort: [
                {
                    field: 'ratingValue',
                    order: 'desc',
                },
            ],
        },
    },
    {
        id: 'a-z',
        value: {
            name: 'A-Z',
            sort: [
                {
                    field: 'name',
                    order: 'asc',
                },
            ],
        },
    },
    {
        id: 'z-a',
        value: {
            name: 'Z-A',
            sort: [
                {
                    field: 'name',
                    order: 'desc',
                },
            ],
        },
    },
]

export const defaultConfig = {
    sort: sortOptions[0],
    serpSize: sizes[0],
    autocompleteSize: window?.cj?.nosto?.newSearchFeatureEnabled ? 1 : 6,
    historySize: 5,
    currency: 'USD'
}

export const PRODUCT_TYPE_MAPPING = {
    "One-time": "Products",
    "Subscription": "Boxes"
}

export const PRODUCT_TYPE_FILTERS = [
    { label: "All", value: "" },
    { label: "Boxes", value: "Subscription" },
    { label: "Products", value: "One-time" },
]
